import {
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    OnInit,
    Component,
    signal,
    ViewEncapsulation,
    Output,
    EventEmitter,
    Input,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25Util } from "../../../util/s25-util";
import { UserprefService } from "../../../services/userpref.service";
import { ViewerMessageService } from "../../../services/viewer.message.service";
import { MasqueradeService } from "../../../services/masquerade.service";
import { S25Help } from "../../s25-help/s25.help.service";
import { S25Const } from "../../../util/s25-const";
import { S25States } from "../../../services/state/state.map";
import { MoreMenu } from "./MoreMenu";
import MenuSection = MoreMenu.MenuSection;
import { Preference } from "../../../pojo/PeferenceI";
import prefData = Preference.prefData;
import { AppPathsService } from "../../../services/app.paths.service";
import MenuItem = MoreMenu.MenuItem;
import { MoreMenuUtil } from "./more.menu.util";
import { S25MasqueradeSwitchRolesComponent } from "../../S25-masquerade/masquerade.switch.roles.component";
import { CordovaService } from "../../../services/cordova.service";
import { Debounce } from "../../../decorators/debounce.decorator";

@TypeManagerDecorator("s25-ng-more-menu")
@Component({
    selector: "s25-ng-more-menu",
    template: `
        <button
            class="c-button c-button--flat c-navToggle"
            (click)="toggleMenu($event)"
            type="button"
            id="more-nav-button"
        >
            <s25-ng-icon [type]="'menu'"></s25-ng-icon>
            <span class="c-nav-more">More</span>
        </button>

        @if (isNavMenuOpen()) {
            <div
                s25-ng-click-outside
                (clickOutside)="closeMenu()"
                class="c-navbarExtra"
                [ngClass]="{ 'c-navbarExtra--hidden': !isNavMenuOpen() }"
                role="menu"
                id="more-nav-content"
            >
                <button class="c-button c-button--flat c-button--close" (click)="closeMenu()" type="button">
                    <s25-ng-icon [type]="'close'"></s25-ng-icon>
                    <span class="visually-hidden">Close menu</span>
                </button>
                @if (!StateMap.dash.isHidden) {
                    <a s25-ng-router-link [stateName]="StateNames.dash" class="c-margin-top--half c-nav-home">
                        <s25-ng-icon [type]="'schedulingAdvanced'"></s25-ng-icon>
                        Home: {{ StateMap.dash.display }}
                    </a>
                }
                @if (!StateMap.rose.isHidden) {
                    <a s25-ng-router-link [stateName]="StateNames.rose" class="c-nav-event">
                        <s25-ng-icon [type]="'navEdit'"></s25-ng-icon>
                        Event Form
                    </a>
                }

                @if (inApp) {
                    <a
                        href="javascript:void(0)"
                        (click)="switchInstance()"
                        class="c-mobileNav--show"
                        id="switch-instance"
                    >
                        <s25-ng-icon [type]="'signout'"></s25-ng-icon>
                        Switch Instance
                    </a>
                }

                @for (section of sections; track section) {
                    @if (section.items.length > 0) {
                        <div class="navTab c-nav--top-border ">
                            <input
                                id="tab-{{ section.name }}"
                                type="checkbox"
                                name="tabs"
                                class="c-tab-input"
                                [checked]="section.expanded"
                                role="button"
                                (click)="menuTabToggle(section)"
                            />
                            <label for="tab-{{ section.name }}" class="c-tab-label">
                                {{ section.header }}
                            </label>
                            <div class="c-menu-content">
                                @if (section.expanded) {
                                    @for (item of section.items; track item) {
                                        @if (item.displayName === "What’s New") {
                                            <a class="c-whatsNew" [href]="item.url" s25Help [helpTopic]="'whats_new'">{{
                                                item.displayName
                                            }}</a>
                                        } @else {
                                            <s25-ng-more-menu-item
                                                [item]="item"
                                                (itemClicked)="closeMenu()"
                                            ></s25-ng-more-menu-item>
                                        }
                                    }
                                }
                            </div>
                        </div>
                    }
                }

                <div class="navTab c-nav--top-border">
                    <p class="c-tab-label c-menu-username">{{ styledName }}</p>

                    @if (isLoggedIn) {
                        @if (!disableSignOut) {
                            <a
                                href="javascript:void(0)"
                                (click)="signOut($event)"
                                class="ngAnchor c-signOut"
                                data-nav-link="signOut"
                            >
                                <s25-ng-icon [type]="'signout'"></s25-ng-icon>
                                Sign Out
                            </a>
                        }
                    } @else {
                        <a href="javascript:void(0)" class="ngAnchor" (click)="logIn.emit()">Sign In</a>
                    }
                </div>
            </div>
        }
    `,
    styles: `
        .c-whatsNew {
            display: block;
        }

        /* Hidden Nav Menu */

        .c-navbarExtra--navLinks {
            padding: 0.25rem 0;
        }

        .c-nav--top-border {
            border-top: 1px solid #ccc;
        }

        .c-nav-home {
            padding-left: 1rem !important;
        }

        .c-menu-content button {
            margin: 0.5rem 1.5rem 0.5rem 2.5rem !important;
        }

        .c-signOut {
            width: 100%;
            margin-bottom: 5px;
            margin-top: -5px;
        }

        .navTab {
            position: relative;
            margin-bottom: 1px;
            width: 100%;
            color: #fff;
            overflow: hidden;
            padding-bottom: 5px;
        }

        .c-tab-input {
            position: absolute;
            opacity: 0;
            z-index: -1;
            &:focus ~ label {
                outline: 1px dotted #212121;
                outline: 5px auto -webkit-focus-ring-color;
            }
        }

        .c-tab-label.c-menu-username {
            line-height: 1.5;
            padding: 0.25em 0 1em 1em;
            word-break: break-all;
        }

        .c-tab-label {
            position: relative;
            display: block;
            padding: 0 0 0 1em;
            line-height: 3;
            cursor: pointer;
            width: 280px;
            color: #2573a7 !important;
            margin-top: 10px;
        }

        .c-menu-content {
            max-height: 0;
            overflow: hidden;
            -webkit-transition: max-height 0.35s;
            -o-transition: max-height 0.35s;
            transition: max-height 0.35s;
        }

        .c-tab-input:checked ~ .c-menu-content {
            max-height: 29em;
            overflow-y: auto;
            display: block;
        }

        /* Icon */

        .c-tab-label::after {
            position: absolute;
            left: 255px;
            top: 0px;
            display: block;
            text-align: center;
            -webkit-transition: all 0.35s;
            -o-transition: all 0.35s;
            transition: all 0.35s;
        }

        .c-tab-input[type="checkbox"] {
            + .c-tab-label::after {
                content: "▾";
            }
            &:checked + .c-tab-label::after {
                transform: rotate(180deg);
            }
        }

        .c-navbarExtra {
            .toggle-wrapper {
                left: 0;
                transform: none;
                margin-top: 0;
                margin-left: 4em;
            }
        }

        .c-nav-event {
            padding: 0 1rem 1rem !important;

            s25-ng-icon {
                position: relative;
                left: 2px;
            }
        }
    `,
    standalone: false,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25MoreMenuComponent implements OnInit {
    @Input() styledName = "";
    @Output() logOut = new EventEmitter<{
        stateName?: S25States.Name;
        keepRecentlyViewed?: boolean;
        keepJwt?: boolean;
    }>();
    @Output() logIn = new EventEmitter<void>();

    inApp: boolean = S25Const.inApp;
    prefs: prefData;
    isLoggedIn: boolean = false;
    disableSignOut: boolean = false;
    isNavMenuOpen = signal(false);

    constructor(private cd: ChangeDetectorRef) {}

    sections: MenuSection[] = [
        {
            header: "Navigate to...",
            name: "navigateTo",
            expanded: true,
            items: [],
        },
        {
            header: "Go to Tool",
            name: "goToTool",
            expanded: false,
            items: [],
        },
        {
            header: "About",
            name: "about",
            expanded: false,
            items: [],
        },
        {
            header: "Switch Roles",
            name: "switchRoles",
            expanded: false,
            items: [],
        },
    ];

    signOut(event: MouseEvent) {
        event.stopPropagation(); // Prevent the click event from propagating
        this.logOut.emit({ stateName: null, keepRecentlyViewed: false, keepJwt: true });
    }

    /*
    this function will init by just showing the three menu bars
    In the background, it will fetch everything needed to fill the more menu.
    on click of that menu, it will show the menu items
     */
    async ngOnInit() {
        this.prefs = await MoreMenuUtil.getPreferences();
        this.isLoggedIn = await UserprefService.getLoggedIn();
        this.disableSignOut = window.disableSignOut && !S25Const.inApp;

        for (const section of this.sections) {
            switch (section.name) {
                case "navigateTo":
                    section.items = await MoreMenuUtil.getNavigateTo();
                    break;

                case "about":
                    section.items = await this.getAboutLinks();
                    break;

                case "goToTool":
                    if (this.isLoggedIn) {
                        section.items = await this.getExternalLinks();
                    }
                    break;

                case "switchRoles":
                    if (this.isLoggedIn) {
                        const currentContactId = await UserprefService.getContactId();
                        const roles = await MasqueradeService.getMasqueradeUsers(currentContactId);

                        if (roles?.length > 0) {
                            section.items = [
                                {
                                    displayName: "Switch Roles",
                                    dynamicValue: { component: S25MasqueradeSwitchRolesComponent },
                                },
                            ];
                        }
                    }
                    break;
            }
        }

        this.cd.detectChanges();
    }

    async getAboutLinks(): Promise<MenuItem[]> {
        const emailPref = `${this.prefs?.config_feedback_email?.value}` || "";

        const [hasViewerMessageResult, feedbackUrlResult] = await Promise.allSettled([
            ViewerMessageService.hasViewerMessageWritePerms(),
            S25Help.getFeedbackUrl(),
        ]);

        const hasViewerMessage = hasViewerMessageResult.status === "fulfilled" ? hasViewerMessageResult.value : false;
        const feedbackUrl = feedbackUrlResult.status === "fulfilled" ? feedbackUrlResult.value : "";
        const retVal: MenuItem[] = [
            {
                displayName: "Welcome Message",
                modalName: "welcome-message",
            },
            {
                displayName: "Edit Viewer Message",
                modalName: "viewer-message",
                isHidden: !hasViewerMessage,
            },
            {
                displayName: "Contact Admin",
                url: S25Util.eMailLink(emailPref),
            },
            {
                displayName: "Product Feedback",
                url: feedbackUrl,
                isHidden: !feedbackUrl,
            },
            {
                displayName: "User Community Forums",
                url: "https://www.series25.community/",
            },
            {
                displayName: "What’s New",
                url: S25Help.getHelpUrl("whats_new"),
            },
            {
                displayName: "Accessibility",
                url: "https://collegenet.com/accessibility",
            },
            {
                displayName: "Copyright",
                modalName: "copyright",
            },
            {
                displayName: "Privacy Policy",
                url: "https://collegenet.com/privacy",
            },
            {
                displayName: "Browser Recommendations",
                modalName: "recommended-browsers",
            },
        ];

        return retVal.filter((item) => !item.isHidden || S25Util.isUndefined(item.isHidden));
    }

    async getExternalLinks(): Promise<MenuItem[]> {
        const apps = await AppPathsService.getExternalApps();
        return apps.map(
            (app) =>
                ({
                    displayName: app.displayName,
                    url: app.url,
                    state: app.state,
                    dynamicValue: app.dynamicValue,
                    isHidden: false,
                }) as MenuItem,
        );
    }

    async switchInstance() {
        CordovaService.removeSecureStorage("S25InstanceId");
        // switch instance but do not destroy their jwt for re-auth later

        return this.logOut.emit({ stateName: null, keepRecentlyViewed: false, keepJwt: true });
    }

    closeMenu() {
        if (this.isNavMenuOpen()) this.toggleMenu();
    }

    @Debounce(100)
    toggleMenu(event?: MouseEvent) {
        event?.stopPropagation();
        this.isNavMenuOpen.update((prev) => !prev);
        this.cd.detectChanges();
    }

    menuTabToggle(section: MenuSection) {
        section.expanded = !section.expanded;
        this.cd.detectChanges();
    }

    protected readonly StateMap = S25States.untyped;
    protected readonly StateNames = S25States.names;
    protected readonly Object = Object;
}
